import React, { PureComponent, Fragment } from 'react';
import MuiAvatar from '@material-ui/core/Avatar';
import styled, { css } from 'styled-components';
import { colors } from '../../../constants/colors';
import { fontSize, fontFamily } from '../../../constants/text';

const Avatar = styled(MuiAvatar)`
  color: ${colors.theWhiteAlbum};
  font-size: ${fontSize.default};
  font-family: ${fontFamily.medium};
  display: inline-block;
  cursor: pointer;
  text-align: center;
  ${(props) => css`
    background-color: ${// @ts-expect-error ts-migrate(2339) FIXME: Property 'backgroundcolor' does not exist on type ... Remove this comment to see the full error message
    props.backgroundcolor};
    border-radius: 50%;
    height: ${// @ts-expect-error ts-migrate(2551) FIXME: Property 'size' does not exist on type 'AvatarProp... Remove this comment to see the full error message
    props.size}px;
    line-height: ${// @ts-expect-error ts-migrate(2551) FIXME: Property 'size' does not exist on type 'AvatarProp... Remove this comment to see the full error message
    props.size}px;
    width: ${// @ts-expect-error ts-migrate(2551) FIXME: Property 'size' does not exist on type 'AvatarProp... Remove this comment to see the full error message
    props.size}px;
  `};
`;

type OwnProps = {
  handleClick?: (...args: any[]) => any;
  backgroundColor?: string;
  src?: string;
  className?: string;
  size?: number;
};

type Props = OwnProps & typeof Circle.defaultProps;

class Circle extends PureComponent<Props> {
  static defaultProps = {
    size: 40,
  };

  render = () => {
    const { handleClick, backgroundColor, src, className, size } = this.props;
    return (
      <Avatar
        className={className}
        // @ts-expect-error ts-migrate(2769) FIXME: Property 'backgroundcolor' does not exist on type ... Remove this comment to see the full error message
        backgroundcolor={backgroundColor}
        onClick={handleClick}
        src={src}
        size={size}
      >
        {this.props.children}
      </Avatar>
    );
  };
}

export default Circle;
